/**
 * Corresponds to the <b>button</b> property possibilities on MouseEvent.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
 */
var MouseEventButton;
(function (MouseEventButton) {
    /** Main button, usually the left button or the un-initialized state */
    MouseEventButton[MouseEventButton["MAIN"] = 0] = "MAIN";
    /** Auxiliary button, usually the wheel button or the middle button (if present) */
    MouseEventButton[MouseEventButton["AUXILIARY"] = 1] = "AUXILIARY";
    /** Secondary button, usually the right button */
    MouseEventButton[MouseEventButton["SECONDARY"] = 2] = "SECONDARY";
    /** Fourth button, typically the Browser Back button */
    MouseEventButton[MouseEventButton["FOURTH"] = 3] = "FOURTH";
    /** Fifth button, typically the Browser Forward button */
    MouseEventButton[MouseEventButton["FIFTH"] = 4] = "FIFTH";
})(MouseEventButton || (MouseEventButton = {}));
export default MouseEventButton;
//# sourceMappingURL=mouse-event-button.js.map